/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {Component, ElementRef, Input, OnChanges, OnInit, ViewChild} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

/*
* */
@Component({
	selector: "aigia-video",
	templateUrl: "./video.component.html",
	styleUrls: ["./video.component.css"],
	/*	animations: [
			trigger("enlarge", [
				state("small", style({width: "100px", height: "80px"})),
				state("large", style({width: "240px", height: "180px"})),
				transition("large <=> small", animate("0.8s ease-in-out")),
			]),
		], */
})

export class VideoComponent implements OnChanges, OnInit {

	@Input() public style: any;
	@Input() public src: string;
	@Input() public active: boolean;
	// @Input() public enlarged: boolean;
	@Input() public size: number[];

// 	public scale: string = "small";

	@ViewChild("video", {read: ElementRef}) private video_ref: ElementRef;

	private innerActive: boolean;
	private innerEnlarged: boolean;
	private video: any;

	constructor(
		public translate: TranslateService
	) {

	}

	/**
	 *
	 */
	public ngOnChanges(changes: any): void {
		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "active":
					this.innerActive = changes.active.currentValue;
					break;
				/*				case "enlarged":
									this.innerEnlarged = changes.enlarged.currentValue;
									if (this.innerEnlarged) {
										this.scale = "large";
									} else {
										this.scale = "small";
									}
									break; */
				case "size":
					const width = changes.size.currentValue[0];
					const height = changes.size.currentValue[1];
					// this.style = {width: width + "px", height: height + "px"};
					// this.style = {width: "100%", height: "300px"};
					this.style = {width: "100%", height: "100%"};
					break;
				default:
			}
		});
	}

	public hackSrc: String;

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
		this.hackSrc = this.src + "#t=0.001";
	}

	/**
	 * @returns none
	 */
	public ngAfterViewInit(): void {
		this.video = this.video_ref.nativeElement;
		this.speedrate(1);
	}

	/**
	 * @returns none
	 */
	public initLayout(): void {
// 		this.scale = "small";
	}

	/**
	 * @returns none
	 */
	public speedrate(rate: number): void {
		this.video.defaultPlaybackRate = rate;
	}

	/**
	 * @returns none
	 */
	public play(): void {
		this.video.play();
	}

	/**
	 * @returns none
	 */
	public speed(rate: number): void {
		this.video.playbackRate = rate;
	}

	/**
	 * @returns none
	 */
	public pause(): void {
		this.video.pause();
	}

	/**
	 * @returns none
	 */
	public top(): void {
		this.video.currentTime = 0;
	}

}
